<template>
    <v-container fluid pt-5>
        <v-toolbar
                flat
                scroll-off-screen
                app
                color="grey lighten-3"
        >
            <img
                height="40"
                src="@/assets/img/logo.png"
            />
            <v-spacer></v-spacer>
            <h3 class="font-weight-light">Recuperar Contraseña</h3>
        </v-toolbar>

        <v-layout wrap justify-center align-center>
            <v-flex xs12 md8 lg6 text-center>
                <template v-if="status=='loading'">
                    <h1 class="headline font-weight-light">Verificando Código</h1>
                    <small class="caption">Un momento por favor...</small>
                </template>

                <template v-if="status=='failed'">
                    <h1 class="headline font-weight-light">Algo salió mal :(</h1>
                    <small class="caption">{{failMessage}}</small>
                </template>

                <template v-if="status === 'verified'">
                    <h1 class="headline font-weight-light">Restablecer Contraseña</h1>
                    <small class="caption">para la cuenta: <b>{{email}}</b></small>
                    <v-layout wrap justify-center align-center>
                        <v-flex xs12 md8 lg6 pt-3>
                            <set-password-form
                                    v-on:error="onError"
                                    v-on:success="onSuccess"
                                    endpoint="password/reset"
                                    :code="code"
                            />
                        </v-flex>
                    </v-layout>
                </template>

                <template>

                    <v-scale-transition>
                        <v-sheet color="transparent" v-show="status === 'success'" height="200">
                            <v-avatar size="60" color="success">
                                <v-icon  color="white">fas fa-user-check</v-icon>
                            </v-avatar>
                            <h1 class="headline font-weight-light mt-2">Contraseña Restablecida</h1>
                            <v-btn class="mt-4" rounded outlined color="primary" :to="{name: 'home'}">Ir al inicio</v-btn>
                        </v-sheet>
                    </v-scale-transition>


                <v-slide-y-transition>
                    <v-progress-linear v-show="status=='loading'" height="2" :indeterminate="true"></v-progress-linear>
                </v-slide-y-transition>

                </template>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import { mapState, mapMutations } from 'vuex'
    import SetPasswordForm from '@/components/common/signup/SetPasswordForm'

    export default{
        components: {SetPasswordForm},
        data(){
            return {
                status: 'loading',
                failMessage: '',
                code: this.$route.params.code,
                email: ''
            }
        },
        mounted(){
            var vm = this
            vm.getCodeInfo()
        },
        methods:{
            ...mapMutations(['showSnackBar']),
            onError(response){
                var vm = this
                vm.failMessage = response.message || 'Ha ocurrido un error inesperado'
            },
            onSuccess(){
                var vm = this
                vm.status = 'success'
            },
            async getCodeInfo(){

                var vm = this
                const response = await ApiUtils.makePost('public/password/reset/verify', {
                    code: vm.code
                })

                if (!response.ok) {
                    vm.status = 'failed'
                    const json = await response.json()
                    vm.failMessage = json.message
                    return
                }

                vm.status = 'verified'
                const json = await response.json()
                vm.email = json.result.email

            }
        },
        computed:{
                ...mapState(['currentUser'])
        }
    }
</script>
